import { render, staticRenderFns } from "./TextAdjust.vue?vue&type=template&id=6a6c768a&"
import script from "./TextAdjust.vue?vue&type=script&lang=js&"
export * from "./TextAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports